export default __webpack_public_path__ + "static/media/Aura-Egg__26.12a8747b.png";